import { CONTACTS, ICONS } from 'shared/presentation/constants';
import { useLocale } from 'shared/presentation/contexts';
import { useTrackedWhatsappLink } from 'shared/presentation/hooks';

import * as S from './styles';

const PhoneIcon = ICONS.PHONE;

const FooterContact: React.FC = () => {
  const { language } = useLocale('shared');

  const contact = CONTACTS[language];
  const trackedLink = useTrackedWhatsappLink({
    event: 'clicou-botao-whats-rodape',
    message: 'Preciso de atendimento da Vialaser',
  });

  return (
    <S.Container>
      <ul>
        <li>
          <a
            href={trackedLink.href}
            target="_blank"
            rel="noopener noreferrer"
            onClick={trackedLink.onClickLink}
          >
            <PhoneIcon />
            {contact}
          </a>
        </li>
      </ul>
    </S.Container>
  );
};

export default FooterContact;
